/* global Parse */

import React, { Component } from 'react';
import { Grid, Image, Form, Segment, Input, Button, Message } from 'semantic-ui-react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ReactGA from 'react-ga';
import '../styles/Login.css';

class LoginClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      error: null
    };
  }

  componentDidMount() {
    const error = this.props.searchParams.get('error');
    if (error) {
      this.setState({error});
    }
  }

  componentDidUpdate(prevProps) {
    const error = this.props.searchParams.get('error');
    const prevError = prevProps.searchParams.get('error');
    if (error !== prevError) {
      this.setState({error});
    }
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = e => {
    e.preventDefault();
    //this.setState({error: null});

    const {username, password} = this.state;

    Parse.User.logIn(username, password).then(user => {
      console.log(user.getUsername()); // eslint-disable-line no-console
      ReactGA.event({
        category: 'User',
        action: 'Login',
        label: user.getUsername()
      });
      this.props.navigate('/protected');
    }).catch(err => {
      console.error(err); // eslint-disable-line no-console
      this.setState({error: err.message});
    });
  }

  render() {
    return (
      <Grid className='login-grid' verticalAlign="middle" textAlign="center">
        <Grid.Column>
          <Image src='/images/download.png' style={{marginBottom: '1.5rem'}} />
          <Form size="large" error={!!this.state.error} onSubmit={this.handleSubmit}>
            <Segment stacked>
              <Form.Field>
                <Input icon='user' iconPosition='left' placeholder='Username' name='username' autoCapitalize='none' autoComplete='off' autoCorrect='off' onChange={this.handleChange}/>
              </Form.Field>
              <Form.Field>
                <Input icon='lock' type='password' iconPosition='left' placeholder='Password' name='password' onChange={this.handleChange}/>
              </Form.Field>
              <Button type='submit' color="black" fluid content='Login'/>
            </Segment>
            <Message error>
              <p style={{textAlign: 'left'}}>{this.state.error}</p>
            </Message>
          </Form>
          <Message>
            <Link to="/forgotpassword">Forgot password?</Link>
          </Message>
        </Grid.Column>
      </Grid>
    );
  }
}

// HOC to inject router hooks into class component
function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  return <LoginClass navigate={navigate} searchParams={searchParams} />;
}

export default Login;